module.exports = __webpack_public_path__ + "media/images/sp/top/icon-location_re-6980f1438d1be47f9d442825f27dbafe.svg";